export default __webpack_public_path__ + "static/media/delivery_truck.b2879393.png";